import { render, staticRenderFns } from "./AltaCargos.vue?vue&type=template&id=6a8c2560"
import script from "./AltaCargos.vue?vue&type=script&lang=js"
export * from "./AltaCargos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports